import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { LiftsView } from "../VIEW/LiftsView";
import { useAuth, ADMIN_EMAIL } from "../FIREBASE/useAuth";
import routeUrls from "../COMPONENTS/navbar/navLink";

function LiftsPage() {
  const { user, loading } = useAuth();
  const history = useHistory();

  useEffect(() => {
    if (!loading && !user) history.replace(`${routeUrls.LOGIN}?from=${routeUrls.LIFTS}`);
  }, [user, loading]);

  if (loading || !user) return null;
  return <LiftsView uid={user.uid} isOwner={(user.email || "").toLowerCase() === ADMIN_EMAIL} />;
}

export default LiftsPage;
